import React from 'react';

function Widget({ content, id, className }) {
  /* eslint-disable no-param-reassign */
  // disable because we always want the class goldencobra_widget to be present so we add it
  // to the given className here instead of creating a new `const` for it
  className = `${className} goldencobra_widget`;
  if (!id) { return <div dangerouslySetInnerHTML={{ __html: content }} className={className} />; }
  return <div dangerouslySetInnerHTML={{ __html: content }} id={id} className={className} />;
}

Widget.propTypes = {
  id: React.PropTypes.string,
  className: React.PropTypes.string,
  content: React.PropTypes.string
};

export default Widget;



// WEBPACK FOOTER //
// ./components/widgets/widget.js